
/**
 * 定义一些常量
 */


//四柱起盘:起始年份
export const CONST_START_END_YEAR = [1940, 2021];

// 十二星座
// 12/22-1/19摩羯, 1/20-2/18水瓶, 2/19-3/20双鱼, 3/21-4/19白羊, 4/20-5/20金牛, 5/21-6/20双子, 
// 6/21-7/22巨蟹, 7/23-8/22狮子, 8/23-9/22处女, 9/23-10/22天秤, 10/23-11/21天蝎, 11/22-12/21射手,
export const CONST_CONSTELLATION_START_DAY = [20, 19, 21, 20, 21, 21, 23, 23, 23, 23, 22, 22];
export const CONST_CONSTELLATION_END_DAY = [19, 18, 20, 19, 20, 20, 22, 22, 22, 22, 21, 21];
export const CONST_CONSTELLATION_TEXT = [
	{index: 9, cText: '摩羯座'},
	{index: 10, cText: '水瓶座'},
	{index: 11, cText: '双鱼座'},
	{index: 0, cText: '白羊座'},
	{index: 1, cText: '金牛座'},
	{index: 2, cText: '双子座'},
	{index: 3, cText: '巨蟹座'},
	{index: 4, cText: '狮子座'},
	{index: 5, cText: '处女座'},
	{index: 6, cText: '天秤座'},
	{index: 7, cText: '天蝎座'},
	{index: 8, cText: '射手座'},
];

// 年月日的中文字符
export const CONST_YEAR_WORD = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
export const CONST_MONTH_WORD = ["正", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "腊"];
export const CONST_DAY_WORD = ["初一", "初二", "初三", "初四", "初五", "初六", "初七", "初八", "初九", "初十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十", "二十一", "二十二", "二十三", "二十四", "二十五", "二十六", "二十七", "二十八", "二十九", "三十", "三十一"];

// 兔的数据:飞天玉兔、兔儿爷、米肥兔、兔司基、劳模兔
export const CONST_COW_WORD = ['飞天玉兔', '兔儿爷', '米肥兔', '兔司基', '劳模兔'];
export const CONST_COW_CLASS = ['aiguo', 'fuqiang', 'hexie', 'youshan', 'jingye'];

export const CONFIG_SHARE_AVATAR_IMAGE = [
	'http://m1.2048.net/mini/images/avatar.png'
];